<div class="site-permission-viewer-container">
  <div class="site-permitted-wrapper d-flex flex-wrap">
    <div
      class="checkbox-wrapper d-flex align-items-center pr-3 w-25"
      *ngFor="let site of sitesWithPermission | async; let ind = index"
    >
      <mat-icon
        class="cursor-pointer mr-1"
        *ngIf="site.siteInfo.siteId === defaultSite"
        color="primary"
        title="Current Default Site"
        (click)="setDefaultSite(site, false)"
        >star</mat-icon
      >
      <mat-icon
        class="cursor-pointer mr-1"
        *ngIf="site.siteInfo.siteId !== defaultSite"
        color="primary"
        title="Set as Default Site"
        (click)="setDefaultSite(site, true)"
        >star_border</mat-icon
      >
      <div class="truncatable" [title]="site.siteInfo.siteName">
        {{ site.siteInfo.siteName }}
      </div>
    </div>
  </div>
  <div class="site-no-permitted-wrapper mt-4">
    <div class="w-100 font-weight-500 pt-3">
      Sites you do not have access to
    </div>
    <div class="site-no-permitted-box d-flex flex-wrap py-3">
      <div
        class="checkbox-wrapper d-flex align-items-center pr-3 w-25"
        *ngFor="let site of sitesNoPermission | async; let ind = index"
      >
        <mat-icon class="invisible mr-1" color="primary">star_border</mat-icon>
        <div class="truncatable" [title]="site.siteInfo.siteName">
          {{ site.siteInfo.siteName }}
        </div>
      </div>
    </div>
  </div>
</div>
